// Home.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Card, Spinner, Alert} from 'react-bootstrap';
import './home.css'; // ensure this is imported
const heroBg='https://res.cloudinary.com/dfs2sqkxy/image/upload/v1766292663/hero-bg-abstract_sc2nn3.png';

export default function Home() {
  const [content, setContent] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomepage = async () => {
      try {
        const res = await fetch(process.env.REACT_APP_API_URL + '/homepage');
        if (!res.ok) {
          throw new Error(`Server error: ${res.status}`);
        }
        const data = await res.json();
        setContent(data);
      } catch (err) {
        setError(err.message || 'Failed to load homepage content');
      } finally {
        setLoading(false);
      }
    };

    fetchHomepage();
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Loading state
  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
        <p>Loading homepage content...</p>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <strong>Error:</strong> {error}
        </Alert>
      </Container>
    );
  }

  return (
    <div>
      
<section
  className="hero-section bg-light py-5"
  style={{ backgroundImage: isMobile ? 'none' : `url(${heroBg})` }}
>


        <Container>
          <Row className="align-items-center">
            <Col md={4}>
              <img src="https://res.cloudinary.com/dfs2sqkxy/image/upload/v1766292848/babak_wmt1ra.png" alt="Babak" className="img-fluid rounded-circle" />
            </Col>
            <Col md={8}>
              <h1>{content.hero.headline}</h1>
              <h4 className="text-muted">{content.hero.subheadline}</h4>
              <div className="mt-3">
                {content.hero.buttons.map((btn, i) => (
                  <Button key={i} href={btn.link} variant={i === 0 ? "primary" : "outline-secondary"} className="me-2">
                    {btn.label}
                  </Button>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Feature Blocks */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="g-4">
            {content.features.map((item, i) => (
              <Col md={3} key={i}>
                <Card className="text-center h-100">
                  <Card.Img variant="top" src={item.image} />
                  <Card.Body>
                    <Card.Title>{item.title}</Card.Title>
                    <Button variant="secondary" href={item.link}>Click</Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
}
